import type { Xinglet } from '@xing-com/crate-xinglet';

import { Routes } from './pages/routes';

export default class Share implements Xinglet {
  public getComponent() {
    return (): JSX.Element => <Routes />;
  }
}
